import Button from '../../../../components/envago/Button/Button';
import Icon from '../../../../components/envago/Icon/Icon';
import { useDispatch, useSelector } from 'react-redux';
import { jobsActions, jobsSelectors } from '../../../../redux/jobs';
import Tooltip from '../../../../components/envago/Tooltip/Tooltip';

const JobSortToolbarItem = () => {
    const dispatch = useDispatch();

    const sortSettings = useSelector(jobsSelectors.getSortSettings);

    console.log('sortSettings', sortSettings);
    const isDefaultSort = sortSettings == undefined || sortSettings?.fields[0]?.fieldName === 'meter.meterNumber';

    const isCustomSort = !(
        sortSettings == undefined ||
        sortSettings?.fields[0]?.fieldName === 'meter.meterNumber' ||
        sortSettings?.fields[0]?.fieldName === 'meter.meterAddress.city'
    );

    const changeSort = () => {
        if (isDefaultSort) {
            dispatch(
                jobsActions.setSortSettings({
                    fields: [
                        {
                            fieldName: 'meter.meterAddress.city',
                            direction: 'ASC',
                        },
                        {
                            fieldName: 'meter.meterAddress.street',
                            direction: 'ASC',
                        },
                        {
                            fieldName: 'meter.meterAddress.houseNumber',
                            direction: 'ASC',
                        },
                        {
                            fieldName: 'meter.meterNumber',
                            direction: 'ASC',
                        },
                    ],
                }),
            );
        } else {
            dispatch(
                jobsActions.setSortSettings({
                    fields: [
                        {
                            fieldName: 'meter.meterNumber',
                            direction: 'ASC',
                        },
                    ],
                }),
            );
        }
    };

    if (isCustomSort) {
        // custom sort means: server gives custom sort order by configuration on other fields
        return null;
    }

    return (
        <div className="content-center h-12" title={isDefaultSort ? 'Sortierung nach Zählernummer' : 'Sortierung nach Adresse'}>
            <Button
                className={'h-9'}
                primary={false}
                ghost={true}
                iconButton={true}
                small={true}
                onClick={changeSort}
                aria={{ 'aria-label': 'Sortierung der Aufträge nach Zählernummer / Adresse' }}
            >
                <Icon
                    aria={{ 'aria-label': isDefaultSort ? 'Icon: Sortierung nach Zählernummer' : 'Icon: Sortierung nach Adresse' }}
                    path={isDefaultSort ? Icon.Path.mdiSortNumericAscending : Icon.Path.mdiSortAlphabeticalAscending}
                    size={'24px'}
                />
            </Button>
        </div>
    );
};
export default JobSortToolbarItem;
